<div class="seat-modal-container">

    <h2 class="modal-title">How many participants ?</h2>

    <div class="icon-wrapper">
        <span class="material-icons" style="font-size:40px;color:#4CAF50;">
            event_seat
        </span>
    </div>
    <div class="booking-type-container" *ngIf="flag">
        <div class="booking-toggle">

            <div
                class="toggle-option"
                [class.active]="bookingType === 'individual'"
                (click)="selectBookingType('individual')">

                <span class="material-icons">person</span>
                <span>Self</span>

            </div>

            <div
                class="toggle-option"
                [class.active]="bookingType === 'group'"
                (click)="bookSlotInfo.editflag !== 'editTrue' && selectBookingType('group')">
                <span class="material-icons">groups</span>
                <span>Multiple</span>

            </div>

        </div>
    </div>

    <div class="session-details">
        <div class="row">
            <span><span class="headarea">Session:</span> <strong class="boldheading">{{ sessionName }}</strong></span>
        </div>
        <div class="row">
            <span><span class="headarea">Time:</span> <strong class="boldheading">{{ slotTime }}</strong></span>
        </div>
        <div class="row">
            <span>
                <span class="headarea">Total participant:</span>
                <strong class="available">{{ totalAvailableSeats }}</strong>
            </span>
        </div>
    </div>
     <!-- Select All -->
    <div class="select-all" *ngIf="userObj?.userType === 'PRINCIPAL' && bookingType === 'group' ">
        <input type="checkbox" [(ngModel)]="selectAll" (ngModelChange)="toggleSelectAll($event)">
        <label>Select All participants</label>
    </div>
    <!-- Teachers -->
    <div class="slot-types">
        <div class="type-card" *ngFor="let teacher of allTeacher; let i=index">

            <div class="type-name">
                {{ teacher.fullName }}
            </div>

            <!-- Just showing available (since no per teacher seat logic) -->
            <div class="type-info">
                <span class="status available" *ngIf="!teacher.selected">
                    Available
                </span>
                 <span class="status availablesleted" *ngIf="teacher.selected">
                    Selected
                </span>
            </div>

            <input type="checkbox" [(ngModel)]="teacher.selected" (ngModelChange)="onTeacherChange(teacher, $event)" [disabled]="bookflag(teacher.isBooked)">

        </div>
    </div>

   

    <!-- Submit -->
    <button class="select-btn" (click)="submitSelection()">
        Submit
    </button>

</div>